export class DepositCategorySearchCriteriaDtoModel {
  limit: number;
  orderBy: string|boolean;
  order: string;
  calcTotalRecords?: boolean;

  keyword_search?: string;
  status: string;
  posting_status: string;
}
  